import React from "react";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import ToastContainer from "react-bootstrap/ToastContainer";
import Toast from "react-bootstrap/Toast";
import ToastHeader from "react-bootstrap/ToastHeader";
import ToastBody from "react-bootstrap/ToastBody";
import Spinner from "react-bootstrap/Spinner";

export const SchoolFeedback = (props) => {
  return (
    <Container fluid={true} className="position-relative">
      <ToastContainer position="top-end" className="pt-2 pe-md-1">
        <Toast show={props.loading} bg="info">
          <ToastBody>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />{" "}
            Getting all feedbacks
          </ToastBody>
        </Toast>
        <Toast
          show={props.error !== null}
          bg="danger"
          onClose={props.dismissError}
        >
          <ToastHeader closeButton={true}>
            <strong className="me-auto">Fetch error</strong>
          </ToastHeader>
          <ToastBody>{props.error}</ToastBody>
        </Toast>
      </ToastContainer>
      <Table hover={true} striped={true} bordered={true} responsive="sm">
        <thead>
          <tr>
            <th>School</th>
            <th>Feedback date</th>
            <th>Findings</th>
            <th>Experience</th>
            <th>Other</th>
          </tr>
        </thead>
        <tbody>
          {props.data.map((f, index) => (
            <tr key={index}>
              <td>{f?.school?.name}</td>
              <td>{new Date(f?.submission_date).toLocaleString()}</td>
              <td>{f?.program_finding}</td>
              <td>{f?.program_experience}</td>
              <td>{f?.other_feedback}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};
